import BusinessInfoNavigation from './BusinessInfoNavigation.component';

export default BusinessInfoNavigation;